import React, { useEffect, useState } from "react";
import Header from "../components/header/Header";
import MainLinks from "../components/navlinks/MainLinks";
import { useTranslation } from "react-i18next";
import usersIcon from "../components/images/users.svg";
import callroutingIcon from "../components/images/call-routing.svg";
import devicesIcon from "../components/images/devices.svg";
import telephoneIcon from "../components/images/telephone.svg";
import billingIcon from "../components/images/billing_1.svg";
import CallFlowsIcon from "../components/images/leftpanel/Call_Flows_Active.svg";
import LunaAiIcon from "../components/images/leftpanel/Luna_Ai_Active.svg";
import codeIcon from "../components/images/Code.svg";
import pdfIcon from "../components/images/pdf.svg";
import rightArrow from "../components/images/right-arrow.svg";
import { useNavigate } from "react-router";
import BlackMode from "../components/NightMode/BlackTheme";
import { MDBIcon, MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBModalBody } from 'mdb-react-ui-kit';
import ImportUser from "../components/editviews/user/ImportUser";
import { getAskLunaView, getGlobalLocationForAccount, saveAskLunaView } from "../apiclients/streamsapi_bridge";
import { admin_doc_url, api_serverUrl, show_links_tab } from "../apiclients/apiurls";
import ChatBotView from "../ai-chat-buddy/features/chatbot/components/ChatBitView";
import { isFiveNineAccount } from "./Login";
import { getImpExpStatusNew, getStreamsProductName } from "../apiclients/CommonUtils";
import ImportProgressWarning from "../apiclients/ImportProgressWarning";
import ImpExpRedirectPopup from "../apiclients/ImpExpRedirectPopup"; // NEW: added for isOwnUser case
import TabIDConstant from "../apiclients/TabIDConstant";
import UIConstant from "../apiclients/UIConstant";
// import PDF1 from "../components/docs/Entra_setup_guide.pdf";
function LandingPage() {
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const msaURL = JSON.parse(sessionStorage.getItem("admin_session"))?.msaURL ?? "";
  const isWholesaleAcc = JSON.parse(sessionStorage.getItem("admin_session"))?.isWholesaleAcc ?? false;
  function redirectTo(e, tpage, stateparams) {
    try {
      if (e) e.preventDefault();
      navigate(tpage, {
        state: stateparams,
      });
    } catch (e) { }
  }

  const [docked, setDocked] = useState(false);
  const [opendocked, setOpenDocked] = useState(false);
  const [isFiveNineAcc, setisFiveNineAcc] = useState(false);
  const streamsProductName = getStreamsProductName();
  const [showWarning, setShowWarning] = useState(false);
  const [sms10dlcdomain, setSms10dlcdomain] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);
  const [warningMessage, setWarningMessage] = useState("");

  // NEW: state for redirect popup (isOwnUser case)
  const [showImpExpRedirect, setShowImpExpRedirect] = useState(false);
  const [importUser, setimportUser] = useState(false);
  const importuserToggle = () => setimportUser(!importUser);
  const [isLoading, setisLoading] = useState(false);
  const [firstRequest, setfirstRequest] = useState(false);

  useEffect(() => {
    setisFiveNineAcc(isFiveNineAccount());
  }, []);

    useEffect(() => {
    const isAdminSession = JSON.parse(sessionStorage.getItem("admin_session"));
    const isAdmin = isAdminSession?.permissions
      ? !isAdminSession?.permissions.includes(UIConstant.ALLOW_ADD_DELETE_EDIT_USER) ||
      !isAdminSession?.permissions.includes(UIConstant.ALLOW_MANAGED_SEAT)
      : false;
    setIsDisabled(isAdmin);
  }, []);

  const getALView = async () => {
    const adminSession = sessionStorage.getItem("admin_session");
    const siteid = adminSession ? JSON.parse(adminSession)?.siteid : null;
    if (!siteid) {
      console.warn("Site ID not found in session.");
      fallbackToSessionValues();
      return;
    }
    try {
      const response = await getAskLunaView(siteid, TabIDConstant.HOME_TAB);
      const respData = await response.json();
      const asklunaview = respData.asklunaview;
      setSms10dlcdomain(respData.sms10dlcdomain);
      console.log("AskLunaView1111 2222response:", asklunaview);
      if (asklunaview === undefined || asklunaview === null) {
        console.warn("AskLunaView is undefined or null, falling back to session values.");
        fallbackToSessionValues();
        return;
      }
      const open = asklunaview * 1 !== 0;
      const docked = asklunaview * 1 === 2;

      setOpenDocked(open);
      setDocked(docked);
    } catch (error) {
      console.error("getALView failed:", error);
      fallbackToSessionValues();
    }
  };

  const fallbackToSessionValues = () => {
    setDocked(sessionStorage.getItem("chatbotDocked") === "true");
    setOpenDocked(sessionStorage.getItem("chatbotOpen") === "true");
  };

  useEffect(() => {
    getALView();
  }, []);

  // UPDATED: now handles all 3 cases — status 0, isOwnUser, and other user/account
  const handleforImpExp = async (e, action) => {
    e.preventDefault();
    const result = await getImpExpStatusNew();
    if (result.status === 0) {
      // Case 0: no operation in progress — proceed normally
      redirectTo(e, action, { openadd: true });
    } else if (result.isOwnUser) {
      // Case 1: own user initiated — show redirect popup
      setShowImpExpRedirect(true);
    } else {
      // Case 2: another user/account initiated — show warning
      const { userInfo } = result;
      if (userInfo?.isaccount) {
        setWarningMessage(t("imp_exp_account_progress", { name: userInfo.name ?? "" }));
      } else {
        setWarningMessage(t("imp_exp_other_user_progress", { name: userInfo?.name ?? "" }));
      }
      warningToggle();
    }
  }


  return (
    <React.Fragment>
      <>
        <div className="MobileNotSupport">
          <div className="position-fixed top-0 w-100 nav-Header ">
            <a className="navbar-brand p-3" href="/home">
              <i className="logo"></i>
            </a>
          </div>
          {/* <div className="d-flex flex-column align-items-center justify-content-center w-80">
            <MDBIcon fas icon="ban" className="Block-Icon" />
            <h4 className="text-center mt-4">
              Streams Admin is not-supported on mobile phones.
            </h4>
            <p className="text-secondary text-center">Try again from a different Desktop/ipad/Tablet device.</p>
          </div> */}
        </div>


        <MainLinks active={1} />
        <header>
          <Header active="21" isopen={opendocked} setDocked={setDocked} setOpenDocked={setOpenDocked} />
        </header>
        <div className="d-none">
          <BlackMode />
        </div>
        <div className={docked && opendocked ? "chatbot-viewadjust" : ""}>
          <main className="page-content toggled homepage" id="page-content">
            <div className="container-fluid pt-2">
              <div className="card">
                <h5 className="card-header fw-600">{t("QuickLinks")}</h5>
                <div className="card-body p-5 pt-3">
                  <div className="row">
                    {/* Call Flows */}
                    {!isFiveNineAcc && (
                      <div className="col-md-3">
                        <div className="quicklinks">
                          <h5 className="d-flex align-items-center">
                            <div className="d-flex align-items-center justify-content-center rounded-circle me-2 quicklinks-locations quicklinks-callflows">
                              <img src={CallFlowsIcon} width={20} height={20} className="me-0" />
                              {/* <MDBIcon fas icon="map-marker-alt" color="white" /> */}
                            </div>
                            {t("CallFlows")}
                          </h5>
                          <div className="mt-3 mb-4">
                            <ul className="p-0 mb-0">
                              <li className="list-group">
                                <a className="link" onClick={(e) => redirectTo(e, "/callflowlanding")}>
                                  <img src={rightArrow} />
                                  {t("ManageCallFlow")}
                                </a>
                                <a className="link" onClick={(e) => handleforImpExp(e, "/callflowlanding")}>
                                  <img src={rightArrow} />
                                  {t("AddCallFlow")}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Luna AI */}
                    {!isFiveNineAcc && (
                      <div className="col-md-3">
                        <div className="quicklinks">
                          <h5 className="d-flex align-items-center">
                            <div className="d-flex align-items-center justify-content-center rounded-circle me-2 quicklinks-locations quicklinks-luna">
                              <img src={LunaAiIcon} width={20} height={20} className="me-0" />
                              {/* <MDBIcon fas icon="map-marker-alt" color="white" /> */}
                            </div>
                            {t("LunaAI")}
                          </h5>
                          <div className="mt-3 mb-4">
                            <ul className="p-0 mb-0">
                              <li className="list-group">
                                <a className="link" onClick={(e) => redirectTo(e, "/luna-landing")}>
                                  <img src={rightArrow} />
                                  {t("ManageLuna")}
                                </a>
                                <a className="link" onClick={(e) => handleforImpExp(e, "/luna-landing")}>
                                  <img src={rightArrow} />
                                  {t("AddLuna")}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Locations */}
                    {!isFiveNineAcc && (
                      <div className="col-md-3">
                        <div className="quicklinks">
                          <h5 className="d-flex align-items-center pt-0">
                            <div className="d-flex align-items-center justify-content-center rounded-circle me-2 quicklinks-locations">
                              <MDBIcon fas icon="map-marker-alt" color="white" />
                            </div> {t("Locations ")}
                          </h5>
                          <div className="mt-3">
                            <ul className="p-0 mb-0">
                              <li className="list-group">
                                <a className="link" onClick={(e) => redirectTo(e, "/loclanding", { openadd: true })}>
                                  <img src={rightArrow} />
                                  {t("addlocation")}
                                </a>
                                <a className="link" onClick={(e) => redirectTo(e, "/loclanding", { tab: "location", tab1: "tab3", open911add: true })}>
                                  <img src={rightArrow} />
                                  {t("add911Location")}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}

                    {!isFiveNineAcc &&
                      <>
                        <div className="col-md-3">
                          <div className="quicklinks">
                            <h5 className="d-flex align-items-center">
                              <img src={usersIcon} />
                              {t("users")}
                            </h5>
                            <div className="mt-3 mb-4">
                              <ul className="p-0 mb-0">
                                <li className="list-group">
                                  <a
                                    className="link"
                                    onClick={(e) => redirectTo(e, "/userlanding")}
                                  >
                                    <img src={rightArrow} />
                                    {t("ManageExistingUser")}
                                  </a>
                                  {!isDisabled && (
                                  <a
                                    className="link"
                                    onClick={(e) => handleforImpExp(e, "/userlanding")}>
                                    <img src={rightArrow} />
                                    {t("add_New_User")}
                                  </a>
                                  )}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </>
                    }
                    {!isFiveNineAcc &&
                      <>
                        <div className="col-md-3">
                          <div className="quicklinks mt-3">
                            <h5 className="d-flex align-items-center">
                              <img src={callroutingIcon} /> {t("phoneSystem")}
                            </h5>
                            <div className="mt-3 mb-2">
                              <ul className="p-0">
                                <li className="list-group">
                                  <a
                                    className="link"
                                    onClick={(e) => redirectTo(e, "/huntgroup")}
                                  >
                                    <img src={rightArrow} />
                                    {t("ManageExistingHuntGroups")}
                                  </a>
                                  <a
                                    className="link"
                                    onClick={(e) => handleforImpExp(e, "/huntgroup")}>
                                    <img src={rightArrow} />
                                    {t("addHuntGroup")}
                                  </a>
                                  {/* {show_links_tab == 1 &&
                                                <a
                                                  className="link"
                                                  onClick={(e) => redirectTo(e, "/pslanding")}
                                                >
                                                  <img src={rightArrow} />
                                                  {t("ManageExistingCallQueues")}
                                                </a>} */}
                                  {/* {show_links_tab == 1 &&
                                                <a
                                                  className="link"
                                                  onClick={(e) => redirectTo(e, "/pslanding")}
                                                >
                                                  <img src={rightArrow} />
                                                  {t("AddCallQueues")}
                                                </a>
                                              } */}

                                  <a
                                    className="link"
                                    onClick={(e) => redirectTo(e, "/autoattendant")}
                                  >
                                    <img src={rightArrow} />
                                    {t("ManageExistingAutoAttendants")}
                                  </a>
                                  <a
                                    className="link"
                                    onClick={(e) => handleforImpExp(e, "/autoattendant")}>
                                    <img src={rightArrow} />
                                    {t("AddAutoAttendants")}
                                  </a>
                                  <a
                                    className="link"
                                    onClick={(e) => redirectTo(e, "/medialanding")}
                                  >
                                    <img src={rightArrow} />
                                    {t("ManageGreetings")}
                                  </a>
                                  {/* <a
                                    className="link"
                                    onClick={(e) =>
                                      redirectTo(e, "/luna-landing", { openadd: true })
                                    }
                                  >
                                    <img src={rightArrow} />
                                    {t("AddLuna")}
                                  </a>
                                  <a
                                    className="link"
                                    onClick={(e) =>
                                      redirectTo(e, "/callflowlanding", { openadd: true })
                                    }
                                  >
                                    <img src={rightArrow} />
                                    {t("AddCallFlow")}
                                  </a> */}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="quicklinks mt-3">
                            <h5 className="d-flex align-items-center">
                              <img src={devicesIcon} /> {t("devices")}
                            </h5>
                            <div className="mt-3 ">
                              <ul className="p-0">
                                <li className="list-group">
                                  <a
                                    className="link"
                                    onClick={(e) => redirectTo(e, "/pslanding?tab=tab2", { tab: "tab2" })}
                                  >
                                    <img src={rightArrow} />
                                    {t("ManageExistingDevices")}
                                  </a>
                                  <a
                                    className="link"
                                    onClick={(e) => redirectTo(e, "/pslanding?tab=tab2", { tab: "tab2", showAddDevice: true })}
                                  >
                                    <img src={rightArrow} />
                                    {t("addDevice")}
                                  </a>
                                  <a
                                    className="link"
                                    onClick={(e) => redirectTo(e, "/pslanding", { tab: "tab1" })}
                                  >
                                    <img src={rightArrow} />
                                    {t("DeviceStatus")}
                                  </a>
                                  {/* <a
                              className="link"
                              // onClick={(e) => redirectTo(e, "/pslanding")}
                            >
                              <img src={rightArrow} />
                              {t("IPPhoneSecurity")}
                            </a> */}
                                  <a
                                    className="link"
                                    // onClick={(e) => redirectTo(e, "/securityregistrationlanding",{tab:"tab2"})}
                                    onClick={(e) => redirectTo(e, "/Securitylanding")}
                                  >
                                    <img src={rightArrow} />
                                    {t("StreamsAppSecurity", { "PRODUCT_NAME": streamsProductName })}
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                      </>
                    }



                    {/* Telephone Numbers */}
                    <div className="col-md-3">
                      <div className="quicklinks mt-3">
                        <h5 className="dflex">
                          <img src={telephoneIcon} /> {t("telephone_Numbers")}
                        </h5>
                        <div className="mt-3">
                          <ul className="p-0 mb-0">
                            <li className="list-group">
                              <a
                                className="link"
                                onClick={(e) => redirectTo(e, "/phonenumbers")}
                              >
                                <img src={rightArrow} />
                                {t("ManageExistingNumbers")}
                              </a>
                              <a
                                className="link"
                                onClick={(e) =>
                                  redirectTo(e, "/phonenumbers", { tab: "tab4" })
                                }
                              >
                                <img src={rightArrow} />
                                {t("PortValidateNumbers")}
                              </a>
                              <a
                                className="link"
                                onClick={(e) =>
                                  redirectTo(e, "/phonenumbers", { tab: "tab1", openadd: true })
                                }
                              >
                                <img src={rightArrow} />
                                {t("PurchaseNumbers")}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* Billing */}
                    <div className="col-md-3">
                      <div className="quicklinks mt-3 ">
                        <h5 className="d-flex align-items-center">
                          <img src={billingIcon} /> {t("billing")}
                        </h5>
                        <div className="mt-3 mb-2">
                          <ul className="p-0">
                            <li className="list-group">
                              <a
                                className="link"
                                onClick={(e) => redirectTo(e, "/billingaccountinfo")}
                              >
                                <img src={rightArrow} />
                                {t("BillingAccountInfo")}
                              </a>
                              {!isWholesaleAcc &&
                                <a
                                  className="link"
                                  onClick={(e) => {
                                    const billingInfo = {
                                      billing_group_type: "Invoice",
                                      billing_group_id: 10000,
                                      quick_payment_link: true,
                                    }
                                    navigate("/billinggroupdetails", {
                                      state: billingInfo
                                    })
                                  }}
                                >
                                  <img src={rightArrow} />
                                  {t("UpdatePaymentInfo")}
                                </a>
                              }
                              <a
                                className="link"
                                onClick={(e) => redirectTo(e, "/billinglanding")}
                              >
                                <img src={rightArrow} />
                                {t("billing_Groups")}
                              </a>
                              {!isWholesaleAcc &&
                                <a
                                  className="link"
                                  onClick={(e) => {
                                    const billingInfo = {
                                      billing_group_type: "Invoice",
                                      billing_group_id: 10000,
                                      tab: "tab5",
                                    }
                                    navigate("/billinggroupdetails", {
                                      state: billingInfo,
                                    })
                                  }}
                                >
                                  <img src={rightArrow} />
                                  {t("Invoices")}
                                </a>
                              }
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
              </div>
              <div className="card mt-3">
                <h5 className="card-header fw-600">{t("HelpDocuments")}</h5>
                <div className="card-body p-5 pt-3">
                  <div className="row pb-4">
                    <div className="col-md-3">
                      <a
                        className="dflex helpdocs"
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            window.open(
                              msaURL,
                              "_blank",
                              "width=1000,height=600,scrollbars=yes,resizable=yes"
                            );
                          }}
                        rel="noreferrer"
                      >
                        {t("enduseragreement")}
                      </a>

                      {!isWholesaleAcc &&
                        <a
                          className="dflex helpdocs"
                          href="#"
                           onClick={(e) => {
                          e.preventDefault();
                          window.open(
                            "https://legal.panterranetworks.com/agreements/sla_agreement.html",
                            "_blank",
                            "width=1000,height=600,scrollbars=yes,resizable=yes"
                          );
                        }}
                          
                          rel="noreferrer"
                        >
                          {t("servicelevelagreement")}
                        </a>
                      }

                      {!isFiveNineAcc && (<>
                        <a className="dflex helpdocs" href={`${api_serverUrl}docs/html/ConnectHelp_v7/index.htm`} target="_blank" rel="noreferrer">
                          {/*  {/* <img src={codeIcon} /> */}
                          {t("ConnectHelp")}
                        </a>
                        <a className="dflex helpdocs" href="https://streams-ai.streams.us/downloads" target="_blank" rel="noreferrer">
                          {/*  {/* <img src={codeIcon} /> */}
                          {t("downloads")}
                        </a>
                        {/* <a className="dflex helpdocs">
                        {t("users")}
                      </a> */}
                        {/* <a className="dflex helpdocs" href={`${admin_doc_url}/docs/html/Admin5WebHelp_v17/index.htm#t=Introduction.htm`} target="_blank" rel="noreferrer">
                        {t("AdminHelp")}
                      </a> */}
                        {/* <a className="dflex helpdocs" href={`${admin_doc_url}/docs/pdfs/RecordingaGreetingviatheTelephonyGreetingManager.pdf`} target="_blank" rel="noreferrer">
                          {t("GreetingManager")}
                        </a> */}
                      </>)}
                      {!(isFiveNineAcc || isWholesaleAcc) &&
                        <a
                          className="dflex helpdocs"
                          href={`${api_serverUrl}docs/pdfs/Streams_Teams_Integration_Help.pdf`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {t("streamsTeamsHelp")}
                        </a>
                      }

                    </div>
                    {!isFiveNineAcc &&
                      <div className="col-md-3">
                        {/* <a className="dflex helpdocs">
                                          {t("FactoryResetProvisioningCiscoSPA")}
                                        </a> */}
                        <a className="dflex helpdocs" href={`${api_serverUrl}docs/pdfs/PolycomQuickStartGuide.pdf`} target="_blank" rel="noreferrer">
                          {/* <img src={pdfIcon} /> */}
                          {t("PolycomQuickstartGuide")}
                        </a>
                        <a className="dflex helpdocs" href={`${api_serverUrl}docs/pdfs/Factory_Reset_and_Provisioning_of_Polycom_Phones.pdf`} target="_blank" rel="noreferrer">
                          {/* <img src={pdfIcon} /> */}
                          {t("FactoryProvisioningPolycom")}
                        </a>
                        <a className="dflex helpdocs" href={`${api_serverUrl}docs/pdfs/YealinkQuickStartGuide.pdf`} target="_blank" rel="noreferrer">
                          {/* <img src={pdfIcon} /> */}
                          {t("YealinkQuickstartGuide")}
                        </a>
                        <a className="dflex helpdocs" href={`${api_serverUrl}docs/pdfs/Factory_Reset_and_Provisioning_of_Yealink_Phones.pdf`} target="_blank" rel="noreferrer">
                          {/* <img src={pdfIcon} /> */}
                          {t("FactoryResetProvisioningYealink")}
                        </a>

                      </div>
                    }
                    {/* <div className="col-md-3"> */}
                    {/* <a className="dflex helpdocs" href={`${admin_doc_url}/docs/pdfs/Manual_Provisioning.pdf`} target="_blank" rel="noreferrer"> */}
                    {/* <img src={pdfIcon} /> */}
                    {/* {t("ManualProvisioning")}
                      </a> */}
                    {/* <a className="dflex helpdocs" href={`${admin_doc_url}/docs/pdfs/Configuring_an_Edgewater.pdf`} target="_blank" rel="noreferrer"> */}
                    {/* <img src={pdfIcon} /> */}
                    {/* {t("ConfigEdgewater")}
                      </a> */}
                    {/* <a className="dflex helpdocs" href={`${admin_doc_url}/docs/pdfs/Configuring_a_Sonicwall.pdf`} target="_blank" rel="noreferrer"> */}
                    {/* <img src={pdfIcon} /> */}
                    {/* {t("ConfigSonicwall")}
                      </a> */}
                    {/* <a className="dflex helpdocs" href={`${admin_doc_url}/docs/pdfs/Configuring_a_Ubiquiti.pdf`} target="_blank" rel="noreferrer"> */}
                    {/* <img src={pdfIcon} /> */}
                    {/* {t("ConfigQbiquiti")}
                      </a> */}
                    {/* <a className="dflex helpdocs" href={`${admin_doc_url}/docs/html/StreamsAPI/index.htm`} target="_blank" rel="noreferrer">
                        {t("StreamsAPIHelp")}
                      </a> */}
                    {/* </div> */}
                    <div className="col-md-3">
                      {/* <a className="dflex helpdocs" href={`${admin_doc_url}/docs/pdfs/VoicemailInstructionsChart.pdf`} target="_blank" rel="noreferrer"> */}
                      {/* <img src={pdfIcon} /> */}
                      {/* {t("VoicemailInstructions")} */}
                      {/* </a> */}
                      {/* <a className="dflex helpdocs">
                        {t("CallFeaturesStarCodes")}
                      </a> */}
                      {/* <a className="dflex helpdocs">
                        {t("CiscoSPAQuickstartGuide")}
                      </a> */}
                      {/* <a className="dflex helpdocs" href={`${admin_doc_url}/docs/pdfs/DHCP_Options_for_Auto_Provisioning.pdf`} target="_blank" rel="noreferrer">
                        {t("DHCPAutoProvisioning")}
                      </a> */}
                      
                       
                      <a className="dflex helpdocs" href={`${api_serverUrl}docs/pdfs/Setup_Guide_Entra_UP_SSO.pdf`} target="_blank" rel="noreferrer">
                          {/* <img src={pdfIcon} /> */}
                          {t("MicrosoftEntraIntegrationHelp")}
                        </a>
                        <a className="dflex helpdocs" href={`${api_serverUrl}docs/pdfs/Zoho_CRM_Integration_with_StreamsAI_Help.pdf`} target="_blank" rel="noreferrer">
                        {t("ZohoHelp")}
                      </a>
                       {/* {isWholesaleAcc && sms10dlcdomain != "" &&
                       <a className="dflex helpdocs" href={`${sms10dlcdomain}`} target="_blank" rel="noreferrer">
                        {t("NewSMS10DLCInstructions")}
                      </a>
                      } */}
                      {/* {!isWholesaleAcc &&
                      <a className="dflex helpdocs" href={`${api_serverUrl}docs/pdfs/10DLC-SMS-Brand-ID-Campaign-Instructions-and-Submission-Form-Fillable.zip`} download rel="noreferrer">
                        {t("NewSMS10DLCInstructions")}
                      </a>
                      }  */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>

        {showWarning && (
          <ImportProgressWarning
            warningToggle={warningToggle}
            setShowWarning={setShowWarning}
            onOk={warningToggle}
            message={warningMessage}
          />
        )}

        {/* NEW: Redirect popup for isOwnUser case */}
        {showImpExpRedirect && (
          <ImpExpRedirectPopup
            onProceed={() => {
              setShowImpExpRedirect(false);
              setfirstRequest(true);
              importuserToggle();
            }}
            onCancel={() => setShowImpExpRedirect(false)}
          />
        )}

        <MDBModal open={importUser} onClose={() => setimportUser(false)} tabIndex='-1'>
          <MDBModalDialog size="fullscreen">
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle>Import User Template</MDBModalTitle>
              </MDBModalHeader>
              <MDBModalBody className="pb-0">
                <ImportUser
                  onClose={importuserToggle}
                  setIsloading={setisLoading}
                  onShow={setimportUser}
                  show={importUser}
                  firstRequest={firstRequest}
                  setfirstRequest={setfirstRequest}
                />
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>

      </>
    </React.Fragment>
  );
}
export default LandingPage;